import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { Provider } from "react-redux";
import React from "react";

import authReducer from "redux/features/auth";
import profileReducer from "redux/features/profile";
import profileResourcesReducer from "redux/features/profileResources";
import changesReducer from "redux/features/changes";
import routesReducer from "redux/features/routes";
import modalReducer from "redux/features/modal";
import optionsSlice from "redux/features/optionData";
import enumeratedDataValuesReducer from "redux/features/enumeratedDataValues";
import countriesReducer from "redux/features/countries";

import verifyEmailReducer from "redux/features/verifyEmail";
import changePasswordReducer from "redux/features/account";

import paymentProcessingReducer from "redux/features/paymentProcessing";
import nonPaymentRegistrationReducer from "redux/features/nonPaymentRegistration";

import thunk from "redux-thunk";

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  profileResources: profileResourcesReducer,
  changes: changesReducer,
  routes: routesReducer,
  modal: modalReducer,
  "options/people": optionsSlice("people").reducer,
  "options/institutions": optionsSlice("institutions").reducer,
  enumeratedDataValues: enumeratedDataValuesReducer,
  countries: countriesReducer,
  verifyEmail: verifyEmailReducer,
  changePassword: changePasswordReducer,
  paymentProcessing: paymentProcessingReducer,
  nonPaymentRegistration: nonPaymentRegistrationReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
});

function OurProvider(props) {
  return <Provider store={store}>{props.children}</Provider>;
}

export default OurProvider;
